export default __webpack_public_path__ + "static/german-1-47412bb1564d7bf784dd3f0ce53a48df.webp";